import React, { useEffect, useState } from 'react'
import { Link } from "react-scroll";
import styled, { css } from "styled-components";
import { useNavigate } from 'react-router-dom';
import useScrollPosition from '../hooks/Scroll';
import {Logo} from "./Logo";

export const HomeNavBar = () => {
  const navigate = useNavigate();
  return (
    <NavContainer>
      <HomeNavMenu>
        <ScrollLink
          activeStyle={{ color:'black' }}
          smooth
          spy
          to="map-page"
        >
          Kaart
        </ScrollLink>
        <ScrollLink
          onClick={() => navigate("/blogs/all-blogs")}
          activeStyle={{ color: 'black' }}
        >
          Blogs
        </ScrollLink>
        <ScrollLink
          activeStyle={{ color: 'black' }}
          smooth
          spy
          to="aboutus-page"
        >
          Over ons
        </ScrollLink>
      </HomeNavMenu>
    </NavContainer>
  )
}

export const InPageNavBar = () => {
  const navigate = useNavigate();
  return (
    <NavContainer>
      <InPageNavMenu>
        <ScrollLink
          onClick={() => navigate(-1)}
          activeStyle={{ color: 'black' }}
        >
          ←
        </ScrollLink>
        <ClickableLogo
          onClick={() => navigate('/')}
        >
          <Logo small/>
        </ClickableLogo>
        <div />
      </InPageNavMenu>
    </NavContainer>
  );
}

const ClickableLogo = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
`;

const NavContainer = ({children, ...otherProps}) => {
  let {scrollUp, position} = useScrollPosition();
  let [navBarVisible, setNavBarVisible] = useState(true);

  useEffect(() => {
    if (scrollUp) {
      setNavBarVisible(true);
    } else {
      setNavBarVisible(position < 100);
    }
  }, [scrollUp, position])

  return (
    <Nav visible={navBarVisible} backgroundGradient={window.scrollY < 350 ? "#0000" : "#000c"} {...otherProps}>
      {children}
    </Nav>
  )
}

const Nav = styled.nav`
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 12;
    position: fixed;
    top: 0;
    ${props => props.backgroundGradient && css`
        background: linear-gradient(${props.backgroundGradient}, #0000);
    `}
    transition: opacity 1s;
    ${props => props.visible ? css`opacity: 1;` : css`opacity: 0;`}

    @media screen and (max-width: 600px) {
    height: 100px;
}
`;

const ScrollLink = styled(Link)`
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    font-family: Poppins;
    font-weight: Bold;
    font-size: 1.5rem;
    text-shadow: 1px 1px #000;
    height: 100%;
    cursor: pointer;
    &:hover {
        color: black;
    }
`;

// HomeNavBar: items centered with equal width per item
const HomeNavMenu = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    ${ScrollLink} {
        width: 200px;

        @media screen and (max-width: 600px) {
            width: 120px;
        }
    }
`;

// InPageNavBar: arrow left, home centered, empty div fills right
const InPageNavMenu = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 1rem;

    ${ScrollLink} {
        width: 80px;

        @media screen and (max-width: 600px) {
            width: 60px;
        }
    }
`;